export default [
  {
    name: 'Electrical Services',
    imgSrc: '/images/sos-55.jpg',
    imgAltText: 'An electrician installing a consumer unit',
    intro: 'From small repairs to complete installations, we offer a full range of electrical services for domestic and commercial properties.',
    listIntro: 'Our Electrical Services Include:',
    list: [
      'Full and partial rewires',
      'Consumer unit (fuse board) upgrades',
      'Additional sockets and lighting installations',
      'Indoor and outdoor lighting solutions',
      'Electrical fault finding and repairs',
      'Electrical testing and inspection (EICRs)',
      'Landlord safety certificates',
      'New build and renovation electrical installations',
      'Security lighting and outdoor power supplies',
      'Smart home and energy-saving solutions'
    ],
    outro: 'All electrical work is carried out to the latest wiring regulations, ensuring your property remains safe, compliant, and efficient.'
  },
  {
    name: 'Solar PV Installation',
    imgSrc: '/images/sos-34.jpg',
    imgAltText: 'Solar panels installed on a residential roof',
    intro: 'Generate your own clean electricity and reduce your reliance on rising energy costs with a professionally installed solar PV system.\n\nOur bespoke solar solutions are designed to maximise energy generation and deliver long-term savings for your home or business.',
    listIntro: 'Benefits of Solar PV:',
    list: [
      'Lower electricity bills',
      'Reduced carbon footprint',
      'Greater energy independence',
      'Increased property value',
      'Long-term return on investment'
    ],
    outro: 'From initial design through to installation and commissioning, we provide a complete turnkey service tailored to your energy needs.'
  },
  {
    name: 'Battery Storage Systems',
    imgSrc: '/images/sos-33.jpg',
    imgAltText: 'A home battery storage unit mounted on a wall',
    intro: 'Make the most of your solar energy by storing excess electricity for use when you need it most.\n\nBattery storage allows you to use more of the energy you generate, reducing reliance on the grid and helping protect against rising energy prices.',
    listIntro: 'Benefits of Battery Storage:',
    list: [
      'Store excess solar energy',
      'Reduce grid electricity usage',
      'Improve energy independence',
      'Backup power options available',
      'Maximise savings from your solar investment'
    ],
    outro: 'We install reliable, high-performance battery systems designed to integrate seamlessly with new or existing solar installations.'
  },
  {
    name: 'EV Charger Installation',
    imgSrc: '/images/sos-23.jpg',
    imgAltText: 'An electric vehicle charging on a home driveway',
    intro: 'Charge your electric vehicle safely and conveniently at home or work with a professionally installed EV charging point.',
    listIntro: 'We supply and install smart EV chargers that allow you to:',
    list: [
      'Charge faster and more efficiently',
      'Monitor energy usage',
      'Schedule charging during off-peak tariffs',
      'Future-proof your property'
    ],
    outro: ''
  },
  {
    name: 'Commercial Electrical Services',
    imgSrc: '/images/sos-18.jpg',
    imgAltText: 'An electrician working in a commercial premises',
    intro: 'We support local businesses with professional electrical services designed to minimise disruption and keep operations running smoothly.',
    listIntro: 'Our commercial services include:',
    list: [
      'Electrical installations and upgrades',
      'Office and retail fit-outs',
      'Emergency lighting',
      'Testing and inspection',
      'Maintenance and fault finding',
      'Energy-efficient lighting solutions'
    ],
    outro: ''
  }
]


// WEBPACK FOOTER //
// ./src/lib/services.js